import React from 'react';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
import Transition from 'react-transition-group/Transition';

const checkIsSafari = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  const userAgentString = _get(window, 'navigator.userAgent');
  // Detect Chrome 
  const chromeAgent = userAgentString.indexOf("Chrome") > -1;
  // Detect Safari 
  let safariAgent = userAgentString.indexOf("Safari") > -1; 
    
  // Discard Safari since it also matches Chrome 
  if (chromeAgent && safariAgent) {
    safariAgent = false;
  }
  return safariAgent;

}

class PageTransition extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      in: false,
      transitionTime: 0,
    };
  }

  componentDidMount() {
    this.setIn(true);
    this.setState({
      transitionTime: this.getTransitionTime(),
    });
  }

  getTransitionTime = () => {
    const time = this.props.transitionTime || 250;
    if (checkIsSafari()) {
      return 10;
    }
    return time;
  }

  getTransitionStyles = () => {
    const styles = this.props.transitionStyles || {
      entering: { opacity: '1' },
      entered:  { opacity: '1' },
      exiting:  { opacity: '0' },
      exited:  { opacity: '0' },
    };

    if (checkIsSafari()) {
      styles.entering = undefined;
    }

    return styles;
  }

  setIn = (inProp) => {
    this.setState({ in: inProp });
  }

  render() {
    const defaultStyle = this.props.defaultStyle || {
      transition: `opacity ${this.state.transitionTime}ms ease-in-out`,
      opacity: '0',
    };

    const transitionStyles = this.getTransitionStyles();

    return (
      <Transition in={this.state.in} timeout={this.state.transitionTime}>
        {state => (
          <div
            style={{
              ...defaultStyle,
              ...transitionStyles[state],
            }}
          >
            {this.props.children}
          </div>
        )}
      </Transition>
    );
  }
}

PageTransition.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.shape({}),
  ]).isRequired,
  transitionTime: PropTypes.number,
  defaultStyle: PropTypes.shape({}),
  transitionStyles: PropTypes.shape({}),
};

export default PageTransition;